import { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { getDataRoleAccount } from '@/controllers/gridManager/accountsManager/accountManager';
import { getConfigCosManager, getIndustrySymbol } from '@/controllers/gridManager/appManager/appManager';
import { ResponseSuccess } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import { connectSocketMarket } from '@/controllers/gridManager/socketManager/SocketManager';
import { initializeAppAction, setAppStartupComplete, setConfigCosAction, setCosInfoAction, setIndustryDataAction } from '@/stores/dataManager/Actions/appAction';
import { connectSocketUserAction } from '@/stores/dataManager/Actions/socketUserAction';
import { Role } from '@/stores/dataStore/memoryStore/const/constIndex';

const InitApp = (props: { initRedux: any, callBackFunc: Function, isNotInitApp: boolean }) => {
    const { initRedux, callBackFunc, isNotInitApp } = props;
    console.log('ha_check_initRedux', { initRedux, callBackFunc, isNotInitApp });
    // const dispatch = useDispatch();
    //Thêm role KH chỉ gọi initapp khi lần đầu render tránh gọi nhiều lần

    useEffect(() => {
        if (initRedux.isLoggedIn) {
            if (initRedux.userInfo.role == Role.CUSTOMER) {
                const { custodycd } = initRedux.userInfo
                getDataRoleAccount(custodycd).then((rs: ResponseSuccess) => {
                    const { isSuccess, data } = rs
                    if (isSuccess) {
                        setCosInfoAction(data)
                    }
                })
                initializeAppAction(initRedux);
                setAppStartupComplete();
                callBackFunc();
                connectSocketUserAction();
                connectSocketMarket()
                getConfigCosManager().then((rs: ResponseSuccess) => {
                    const { isSuccess, data } = rs
                    if (isSuccess) {
                        setConfigCosAction(data)
                    }
                })

                getIndustrySymbol().then((rs: ResponseSuccess) => {
                    const { isSuccess, data } = rs
                    if (isSuccess) {
                        setIndustryDataAction(data)
                    }
                })

            }
        }
    }, [])

    return (
        <>
        </>
    );
};


export default InitApp;